import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import Container from '../../components/container';
import Layout from '../../components/layout';
import TutorialPreviewItem from '../../components/tutorial-preview-item';
import logo from '../../monogram.svg';
import presets from '../../utils/presets';
import { options, rhythm } from '../../utils/typography';
import tutorials from './tutorials.yml';

const TutorialIndex = ({ location }) => (
  <Layout location={location}>
    <div
      css={{
        [presets.Tablet]: {
          paddingBottom: rhythm(options.blockMarginBottom * 4),
        },
      }}
    >
      <Helmet>
        <title>Zoomdata Developer Tutorials</title>
      </Helmet>
      <Container
        css={{
          [presets.Tablet]: {
            background: `url(${logo})`,
            paddingBottom: `${rhythm(
              options.blockMarginBottom * 4,
            )} !important`,
            backgroundSize: `30px 30px`,
            backgroundRepeat: `no-repeat`,
            backgroundPosition: `bottom center`,
          },
        }}
      >
        <h1
          css={{
            color: presets.colors.zoomdataGreen,
            marginTop: 0,
            [presets.Tablet]: {
              marginTop: 0,
              position: `absolute`,
              width: 1,
              height: 1,
              padding: 0,
              overflow: `hidden`,
              clip: `rect(0,0,0,0)`,
              whiteSpace: `nowrap`,
              clipPath: `inset(50%)`,
            },
          }}
        >
          Developer Tutorials
        </h1>
        {tutorials[0].items.map(tutorial => (
          <TutorialPreviewItem
            tutorial={tutorial}
            key={tutorial.link}
            css={{
              marginBottom: rhythm(options.blockMarginBottom),
              [presets.Tablet]: {
                background: `#fff`,
                borderRadius: presets.radiusLg,
                boxShadow: `0 3px 10px rgba(25, 17, 34, 0.05)`,
                padding: rhythm(options.blockMarginBottom * 2),
                paddingLeft: rhythm(options.blockMarginBottom * 3),
                paddingRight: rhythm(options.blockMarginBottom * 3),
                transition: `transform ${presets.animation.speedDefault} ${
                  presets.animation.curveDefault
                },  box-shadow ${presets.animation.speedDefault} ${
                  presets.animation.curveDefault
                }, padding ${presets.animation.speedDefault} ${
                  presets.animation.curveDefault
                }`,
                '&:hover': {
                  transform: `translateY(-4px)`,
                  boxShadow: `0 10px 42px rgba(25, 17, 34, 0.1)`,
                },
                '&:active': {
                  boxShadow: `0 3px 10px rgba(25, 17, 34, 0.05)`,
                  transform: `translateY(0)`,
                  transition: `transform 50ms`,
                },
              },
              [presets.Desktop]: {
                marginLeft: rhythm(-options.blockMarginBottom * 2),
                marginRight: rhythm(-options.blockMarginBottom * 2),
              },
              [presets.Hd]: {},
            }}
          />
        ))}
      </Container>
    </div>
  </Layout>
);

TutorialIndex.propTypes = {
  location: PropTypes.object,
};

export default TutorialIndex;
